import sdk from '@trazi/opt-out/sdk/node';

const optOutSDK = window => {
  const url = window ? window.location.origin : process.env.BASE_URL;
  return sdk(`${url}/api`);
};

export default optOutSDK;
